/**
 * Filled by data from API call
 * /umbraco/delivery/api/v2/content?filter=contentType:imageAnswerTranslationItem
 */
export default class ImageAnswerTranslationItem {
    fetchKey: string;
    imageUrl: string | null;
    title: string | null;
    description: string | null;
    
    constructor(fetchKey: string, imageUrl: string | null, title: string | null, description: string | null) {
        this.fetchKey = fetchKey;
        this.imageUrl = imageUrl;
        this.title = title;
        this.description = description;
    }
    
    getImageUrl() : string | undefined {
        if(this.imageUrl == null) return undefined;
        return this.imageUrl;
    }
}

export interface ImageAnswerTranslationItemProperties {
    imageAnswerTranslationItem : ImageAnswerTranslationItem | undefined;
}